import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import classnames from 'classnames';

import './quickReplyButton.scss';

type Props = {
  className?: string;
  onClick: () => void;
  quickReply: string;
  testId?: string;
};

export const QuickReplyButton = ({ className, onClick, quickReply, testId }: Props) => (
  <button className={classnames('quick-reply-button', className)} data-test={testId} onClick={onClick}>
    <Text as="span" color={COLORS.yuma.$01} size="SM" weight="bold">
      {quickReply}
    </Text>
  </button>
);
